import { render, staticRenderFns } from "./galileoaktarim.vue?vue&type=template&id=a5d4dd02&"
import script from "./galileoaktarim.vue?vue&type=script&lang=js&"
export * from "./galileoaktarim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports